/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Button from 'react-bootstrap/Button'
import { Alert } from 'react-bootstrap'
import * as H from 'history'
import  React from 'react'
import { DocumentReformController } from '../../../controllers/DocumentReformController'
import { MilestoneReportDocumentModel } from '../../../models/MilestoneReportDocumentModel'
import { MilestoneReportModel } from '../../../models/MilestoneReportModel'
import { MilestoneModel } from '../../../models/MilestoneModel'
import { IField } from '../../../shared/fields'

import { TableBody, TableColumn, TableHeader } from '../../../shared/table'
import {
  DocumentTypeInfo, isMilestoneReportDocumentPendingScoring, isMilestoneReportDocumentValid, isMilestoneDocumentInfected,
} from './DocumentTypeInfo'

export interface DocumentSectionProps {
    history: H.History
    model: MilestoneReportModel
    info: DocumentTypeInfo
    item: string
    onChange: { (changes: Partial<MilestoneModel>): any }
}

export interface DocumentSectionState {
    errorMessage?: string
}

export class MilestoneReportDocumentSection extends React.Component<DocumentSectionProps, DocumentSectionState> implements IField {
    ajax: DocumentReformController
    container: HTMLDivElement

    constructor(props: DocumentSectionProps) {
      super(props)
      this.ajax = new DocumentReformController()

      this.state = {
        errorMessage: null,
      }
    }

    downloadFile(blobId: string) {
      window.open(`/api/DocumentReform/downloadMilestoneReport?applicationId=${this.props.model.milestoneModel.applicationID}&blobid=${blobId}`, '_blank')
    }

    getErrorMessage(): string {
      if (this.props.info.required(this.props.model, this.props.item) === true) {
        if (this.getItems().length === 0) {
          return 'Required'
        }
      }
      return null
    }

    getItems = () => {
      const { model, info } = this.props

      // return model.milestoneModel.milestoneReportDocuments ? model.milestoneModel.milestoneReportDocuments.filter((d) => d.code === info.code) : []
      // bugfix 18/Jul/2023: #122160: MilestoneRpt attachments reside within specific yearFolders, needs to be handled differently
      // convert year into yearRange, e.g. "2023" => "2022-23";
      // const year = model.milestoneFinYearName ;
      // const previousYear = Number(year) - 1;
      // const endingYear = year.slice(-2);
      // const yearRange = `${previousYear}-${endingYear}`;
      const startYear = (new Date(model.milestoneModel.grantYearStartDate)).getFullYear()
      const endYear = (new Date(model.milestoneModel.grantYearEndDate)).getFullYear().toString().slice(-2)
      const yearRange = `${startYear}-${endYear}`

      const attachmentsArr = model.milestoneModel.milestoneReportDocuments // contains All attachments under the Application folder in Azure BLOB storage, not just for the chosen milestone Reports
      const filteredItems = attachmentsArr
        ? attachmentsArr.filter((item) => {
          if (item.parentFolder === '07 Milestone Report') {
            return item.code === info.code && item.folder.substr(-7) === yearRange // folder= "Milestone Report 2022-23"
          }
          return item.code === info.code
        })
        : []
      return filteredItems
    }

    removeFile(blobId: string) {
      if (confirm('Are you sure you want to delete the uploaded file?')) {
        this.ajax.deleteMilestoneReport(null, this.props.model.milestoneModel.applicationID, blobId, (d: MilestoneReportDocumentModel[]) => {
          this.props.onChange({ milestoneReportDocuments: d })
        })
      }
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
      const errorMessage = this.getErrorMessage()
      this.setError(errorMessage, () => {
        if (errorMessage) {
          if (focus === true) {
            this.focus()
          }
        }
        callback && callback(!errorMessage)
      })
    }

    setError(errorMessage?: string, callback?: { (): any }) {
      this.setState({ errorMessage }, callback)
    }

    focus() {
      const temp = this.container.getElementsByTagName('button')
      if (temp && temp.length > 0) {
        temp[0].focus()
      }
    }

    getStatus(r: MilestoneReportDocumentModel): JSX.Element | string {
      if (isMilestoneReportDocumentValid(r) || false) return <div className="fas fa-check" />

      if (isMilestoneReportDocumentPendingScoring(r)) return <div className="fas fa-spinner fa-spin" />

      if (isMilestoneDocumentInfected(r)) {
        return (
          <Alert className="emdg-page-alerts emdg-page-alerts--error">
            This file has been marked as infected by antivirus software and cannot be scored. Please remove and upload a valid file.
          </Alert>
        )
      }

      return 'Applicant to confirm'
    }

    render() {
      const {
        model, info, item, history,
      } = this.props
      const { errorMessage } = this.state
      const items = model.milestoneModel.milestoneReportDocuments ? this.getItems() : []

      const acceptMultiple = info.multipleFiles(model.milestoneModel, item)

      const columns: TableColumn<MilestoneReportDocumentModel>[] = [
        { name: 'File name', content: (r) => <a href="#" onClick={(e) => { e.preventDefault(); this.downloadFile(r.blobID) }}>{r.documentName}</a> },
        { name: '', content: (r) => <a className="float-right" href="#" onClick={(e) => { e.preventDefault(); this.removeFile(r.blobID) }}>Remove</a> },
      ]

      return (
        <div
          ref={(r) => { this.container = r }}
          className={'table-container'
            + `${errorMessage ? ' table-container-invalid' : ''}`}
        >
          <TableHeader label={info.title}>
            <Button
              id={`btnAdd${(info.title || '').replace(/ /g, '_')}`}
              className="emdg-btn ml-2 prepare-btn "
              onClick={() => history.push(`/milestone-report/${model.milestoneModel.milestoneReportID}/documents/${info.code}/${item}`)}
            >
              {(acceptMultiple || items.length === 0) ? 'Add' : 'Replace'}
            </Button>
          </TableHeader>
          <div style={{ display: items.length > 0 ? '' : 'none' }}>
            <TableBody<MilestoneReportDocumentModel>
              id="documents"
              columns={columns}
              value={items}
              noRowsMessage="No document(s) uploaded"
              alwaysShowAllRows
            />
          </div>
        </div>
      )
    }
}
